export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PHONE = "+91 81299 50798";
export const PHONE_LINK = "tel:+918129950798";
export const EMAIL = "oregotours@gmail.com";
export const ADDRESS = "KK Buildings, 1st Floor, Edappally–Pukkattupady Rd, Kuzhivelippady, Ernakulam, Kerala 683561";

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/tours", label: "Tours", testid: "nav-link-tours" },
  { to: "/cab-taxi", label: "Cab & Taxi", testid: "nav-link-cab-taxi" },
  { to: "/international", label: "International", testid: "nav-link-international" },
  { to: "/about", label: "About", testid: "nav-link-about" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=2000&q=80",
  road: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?auto=format&fit=crop&w=1600&q=80",
  mountains: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1600&q=80",
  cta: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=2000&q=80",
  driver: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=1600&q=80",
  about: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=1600&q=80",
  indiaService: "https://images.unsplash.com/photo-1564507592333-c60657eea523?auto=format&fit=crop&w=1200&q=80",
  cabService: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&w=1200&q=80",
  intlService: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&w=1200&q=80",
};

export const SERVICES = [
  {
    id: "india",
    testid: "service-card-india",
    title: "India Tours",
    accent: "Incredible",
    description:
      "Hand-crafted journeys across India's forts, backwaters, mountains and ghats — planned around your pace, not a brochure.",
    image: IMAGES.indiaService,
    link: "/tours",
    cta: "Explore India Tours",
  },
  {
    id: "cab",
    testid: "service-card-cab",
    title: "Cab & Taxi Services",
    accent: "Seamless",
    description:
      "Chauffeur-driven sedans, SUVs and coaches with vetted professional drivers — airport transfers to cross-country road trips.",
    image: IMAGES.cabService,
    link: "/cab-taxi",
    cta: "Book a Ride",
  },
  {
    id: "international",
    testid: "service-card-international",
    title: "International Tours",
    accent: "Exquisite",
    description:
      "From overwater villas in the Maldives to alpine rail journeys in Switzerland — the world, minus the planning stress.",
    image: IMAGES.intlService,
    link: "/international",
    cta: "See the World",
  },
];

export const STATS = [
  { testid: "stat-item-travelers", value: 500, suffix: "+", label: "Happy Travelers" },
  { testid: "stat-item-tours", value: 50, suffix: "+", label: "Destinations" },
  { testid: "stat-item-support", value: 24, suffix: "/7", label: "Customer Support" },
  { testid: "stat-item-satisfaction", value: 100, suffix: "%", label: "Customised" },
];

export const WHY_FEATURES = [
  {
    icon: "PenLine",
    title: "Customised Itineraries",
    text: "Every route, stay and stop is built around you — no fixed departures, no tourist traps.",
  },
  {
    icon: "ShieldCheck",
    title: "Vetted Professional Drivers",
    text: "Background-verified chauffeurs who know the ghats, the shortcuts and the stories.",
  },
  {
    icon: "Clock",
    title: "Round-the-Clock Support",
    text: "A real human answers at 3 AM. Flight delayed, plans changed — we reroute in minutes.",
  },
  {
    icon: "MapPin",
    title: "Local Expertise",
    text: "Guides who grew up where you're going, from Old Delhi's lanes to Leh's high passes.",
  },
];

export const STEPS = [
  { icon: "MessageSquare", title: "Enquire", text: "Tell us where you're dreaming of — call, form or WhatsApp." },
  { icon: "SlidersHorizontal", title: "Customise", text: "We shape a route around your dates, budget and pace." },
  { icon: "BadgeCheck", title: "Confirm", text: "Transparent pricing, locked-in hotels and your driver assigned." },
  { icon: "Plane", title: "Travel", text: "Just pack. We watch the road, the weather and the details." },
];

export const FLEET = [
  {
    name: "Executive Sedan",
    model: "Toyota Camry / Skoda Superb",
    capacity: "4 Passengers",
    luggage: "2 Large Bags",
    price: "₹18 / km",
    image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&w=1200&q=80",
  },
  {
    name: "Premium SUV",
    model: "Toyota Fortuner / Mahindra XUV700",
    capacity: "6–7 Passengers",
    luggage: "4 Large Bags",
    price: "₹24 / km",
    image: "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=1200&q=80",
  },
  {
    name: "Luxury Coach",
    model: "Volvo Multi-Axle / Force Urbania",
    capacity: "15–24 Passengers",
    luggage: "Full Hold",
    price: "₹42 / km",
    image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=1200&q=80",
  },
];

export const TESTIMONIALS = [
  {
    name: "Ananya Sharma",
    trip: "Golden Triangle, 6 days",
    quote:
      "The Taj at sunrise with zero crowds — our driver knew exactly when to leave. Every hotel felt hand-picked for us, not booked off a list.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Rohan Mehta",
    trip: "Ladakh Odyssey, 8 days",
    quote:
      "Khardung La in a snowstorm and I never worried once. Orego's team rerouted us overnight and still got us to Pangong for sunrise.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Priya & Karthik",
    trip: "Maldives honeymoon, 5 days",
    quote:
      "Seaplane transfers, a floating breakfast, a surprise sunset cruise — they planned our honeymoon better than we could have dreamed.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "James Whitfield",
    trip: "Rajasthan Heritage, 7 days",
    quote:
      "I've used agencies on four continents. Nobody answers at 2 AM like Orego does. The Jaisalmer desert camp was pure cinema.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Meera Nair",
    trip: "Kerala Backwaters, 5 days",
    quote:
      "A houseboat to ourselves, a chef who adjusted every meal for my mother's diet, and a driver who felt like family by day two.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80",
  },
];

export const MARQUEE_ITEMS = [
  "Incredible India",
  "Golden Triangle",
  "Kerala Backwaters",
  "Royal Rajasthan",
  "Himalayan Roads",
  "Maldives",
  "Swiss Alps",
  "Bali",
  "24×7 On The Road",
];
